import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { draftNoteAPI } from '../../utilities/api';
import { DraftNote } from '../../utilities/interfaces/DraftNote';

interface noteTypeState {
  draftNotes: DraftNote[];
}

const initialState: noteTypeState = {
  draftNotes: [],
};

const draftNoteSlice = createSlice({
  name: 'draftNote',
  initialState,
  reducers: {
    setUpdatedDraftNote(state, action: PayloadAction<DraftNote>) {
      let index = state.draftNotes.findIndex((note: DraftNote) => note.id === action.payload.id);
      if (index !== -1) {
        state.draftNotes[index] = action.payload;
      }
    },
    clearDraftNotes(state) {
      state.draftNotes = [];
    },
  },
  extraReducers(builder) {
    builder.addCase(getDraftNotesByDraftId.fulfilled, (state, action: any) => {
      state.draftNotes = action.payload;
    });
    builder.addCase(createDraftNote.fulfilled, (state, action: any) => {
      state.draftNotes.push(action.payload);
    });
    builder.addCase(updateDraftNote.fulfilled, (state, action: any) => {});
    builder.addCase(deleteDraftNote.fulfilled, (state, action: any) => {
        state.draftNotes = state.draftNotes.filter(x => x.id !== action.meta.arg);
    });
  },
});

export const getDraftNotesByDraftId = createAsyncThunk(
  'stateDraftNotes/getDraftNotes',
  async (id: number) => {
    const response = await draftNoteAPI.getByDraftId(id);
    return response;
  }
);

export const createDraftNote = createAsyncThunk(
  'stateDraftNotes/createDraftNote',
  async (note: DraftNote) => {
    const response = await draftNoteAPI.createDraftNote(note);
    return response;
  }
);

export const updateDraftNote = createAsyncThunk(
  'stateDraftNotes/updateDraftNote',
  async (note: DraftNote) => {
    const response = await draftNoteAPI.updateDraftNote(note);
    return response;
  }
);

export const deleteDraftNote = createAsyncThunk(
  'stateDraftNotes/deleteDraftNote',
  async (id: number) => {
      return await draftNoteAPI.delete(id);
  }
);

export const { setUpdatedDraftNote, clearDraftNotes } = draftNoteSlice.actions;
export default draftNoteSlice.reducer;
